export default __webpack_public_path__ + "static/logo-fidelity-3a78e82bcc4e7e846418621f781160aa.png";